import axiosInstance from "./axiosInstance";

const assistantFile = {
    sendFilesToStorage: (formData, storageId, userId) =>
        axiosInstance.post(`/file/upload/${storageId}/${userId}`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }),

    deleteFileFromStorage: (fileOpenaiId, storageId, userId) =>
        axiosInstance.delete(`/file/${fileOpenaiId}/${storageId}?userId=${userId}`),

    listStorageFiles: (storageId, userId) =>
        axiosInstance.get(`/files/list/${storageId}?userId=${userId}`),

    getTotalSizeOfFiles: (userId) =>
        axiosInstance.get(`/files/total-size/${userId}`)
};

export default assistantFile;
